// extracted by mini-css-extract-plugin
export default {"chat":"Chat_chat__bfife"};